module.exports = __webpack_public_path__ + "static/img/123.9f680963.png";